/**
 * Get list array from GET API response.
 * API list shape: { data: [], meta: { ... } }
 */

export function getListFromApiResponse(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;

  const candidates = [
    raw?.data?.data,
    raw?.data?.list,
    raw?.data?.users,
    raw?.data?.result?.list,
    raw?.data?.result?.data,
    raw?.data?.result,
    raw?.data?.records,
    raw?.data?.items,
    raw?.result?.list,
    raw?.result?.data,
    raw?.result,
    raw?.data,
    raw?.list,
    raw?.users,
    raw?.records,
    raw?.items,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
  }

  return [];
}
